import * as Screens from '~/Application/Screens';
import { Route } from '~/Router';
export var LoginRoute = new Route(Screens.PasswordLogin, '/prihlaseni', function () { return '/prihlaseni'; });
export var PasswordSetupRoute = new Route(Screens.PasswordSetup, '/zmena-hesla', function () {
    throw new Error();
});
export var AccountConfirmationRoute = new Route(Screens.InvitationAccept, '/dokonceni-registrace', function () {
    throw new Error();
});
export var GdprConsentRoute = new Route(Screens.GdprConsent, '/gdpr', function () { return '/gdpr'; });
export var PasswordResetRoute = new Route(Screens.PasswordReset, '/zapomenute-heslo', function () { return '/zapomenute-heslo'; });
export var ImpersonateRoute = new Route(Screens.Impersonate, '/impersonate', function () {
    throw new Error();
});
var createInfoCardsLink = function (props) {
    var filter = props.filter, id = props.id;
    var searchParams = new URLSearchParams();
    filter === null || filter === void 0 ? void 0 : filter.conditions.forEach(function (condition) {
        searchParams.append('filter', "".concat(condition.type, ":").concat(condition.value));
    });
    var query = searchParams.toString();
    return "".concat(id !== undefined ? "/aktuality/".concat(encodeURIComponent(id)) : '', "/").concat(query !== '' ? "?".concat(query) : '');
};
export var DashboardRoute = new Route(Screens.Dashboard, '/', createInfoCardsLink);
export var InfoCardRoute = new Route(Screens.Dashboard, '/aktuality/:id', createInfoCardsLink);
export var ReportsRoute = new Route(Screens.Reports, '/reporty/', function () { return '/reporty/'; });
export var NotificationsFeedRoute = new Route(Screens.NotificationsFeed, '/notifikace', function (_a) {
    var _b = _a.notificationId, notificationId = _b === void 0 ? null : _b, _c = _a.status, status = _c === void 0 ? null : _c;
    var params = new URLSearchParams();
    if (notificationId !== null) {
        params.append('notificationId', notificationId);
    }
    if (status !== null) {
        params.append('status', status);
    }
    var query = params.toString();
    return "/notifikace".concat(query !== '' ? "?".concat(query) : '');
});
export var NotificationEmailDetailRoute = new Route(Screens.NotificationEmailDetail, '/notifikace/:notificationId/email/:emailId', function (_a) {
    var notificationId = _a.notificationId, emailId = _a.emailId;
    return "/notifikace/".concat(encodeURIComponent(notificationId), "/email/").concat(encodeURIComponent(emailId));
});
export var ReportRoute = new Route(Screens.Report, '/reporty/:id', function (_a) {
    var id = _a.id, historized = _a.historized, _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.sortFields, sortFields = _c === void 0 ? [] : _c;
    var searchParams = new URLSearchParams();
    if (page !== 1) {
        searchParams.set('page', String(page));
    }
    if (historized !== undefined) {
        searchParams.append('data-version-id', String(historized));
    }
    sortFields.forEach(function (sortField) {
        searchParams.append('sortField', "".concat(sortField.property, ",").concat(sortField.direction));
    });
    var query = searchParams.toString();
    return "/reporty/".concat(encodeURIComponent(id)).concat(query !== '' ? "?".concat(query) : '');
});
export var UserProfileRoute = new Route(Screens.UserProfile, '/profil/', function () { return '/profil/'; });
export var NotFoundRoute = new Route(Screens.NotFound, '/:rest*', function () {
    throw new Error('Cannot create link to not found screen');
});
